module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "app-footer"
  }, [_c('a', {
    attrs: {
      "href": "http://coreui.io"
    }
  }, [_vm._v("\n    CoreUI\n  ")]), _vm._v("\n  © " + _vm._s(_vm.getYear()) + " creativeLabs.\n  "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "float-right"
  }, [_vm._v("\n    Powered by\n    "), _c('a', {
    attrs: {
      "href": "http://coreui.io"
    }
  }, [_vm._v("\n      CoreUI\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30e606dd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 861
// module chunks = 0